import { SupplyAppsTable } from './components/SupplyAppsTable';
import { SupplyTabs } from './SupplyTabs';

export function SupplyAppsPage() {
  return (
    <>
      <SupplyTabs />
      <main className="page-gutter min-w-0 flex-1 py-4 md:py-6">
        <SupplyAppsTable />
      </main>
    </>
  );
}
